/**
 * =============================================================================
 * YAML Viewer Component (issue #20)
 * =============================================================================
 *
 * Monospace YAML preview with lightweight syntax highlighting
 * (src/utils/yamlHighlight.ts — no external/CDN highlight library).
 * Tokens are rendered as React nodes (no dangerouslySetInnerHTML).
 */

import { tokenizeYamlLine } from '../utils/yamlHighlight'

interface YamlViewerProps {
  /** Raw YAML text */
  yaml: string
  /** Max height CSS class (default max-h-96) */
  maxHeightClass?: string
}

const YamlViewer: React.FC<YamlViewerProps> = ({ yaml, maxHeightClass = 'max-h-96' }) => {
  const lines = yaml.replace(/\r\n/g, '\n').split('\n')

  return (
    <pre
      data-testid="yaml-viewer"
      className={`p-4 bg-gray-900 text-gray-100 rounded-lg overflow-auto text-xs font-mono leading-5 ${maxHeightClass}`}
    >
      {lines.map((line, idx) => (
        <div key={idx} className="whitespace-pre">
          {tokenizeYamlLine(line).map((token, tIdx) => (
            <span key={tIdx} className={token.className}>
              {token.text}
            </span>
          ))}
          {line === '' ? ' ' : null}
        </div>
      ))}
    </pre>
  )
}

export default YamlViewer
